
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface NewsCardProps {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
}

const NewsCard = ({ id, title, description, imageUrl }: NewsCardProps) => {
  return (
    <Link to={`/article/${id}`}>
      <Card className="overflow-hidden hover:shadow-lg transition-shadow duration-300 mx-2 cursor-pointer h-full flex flex-col">
        <div className="relative h-56">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>
        <CardContent className="p-6 flex flex-col flex-grow">
          <h3 className="text-xl font-semibold mb-3 line-clamp-2 min-h-[3.5rem]">{title}</h3>
          <p className="text-gray-600 line-clamp-3">{description}</p>
        </CardContent>
      </Card>
    </Link>
  );
};

export default NewsCard;
